// extracted by mini-css-extract-plugin
export var blockedMessage = "_c1-3";
export var blockedOverlay = "_c1-1";
export var fadeIn = "_c1-2";
export var hereLink = "_c1-0";
export var slideUp = "_c1-4";